export default __webpack_public_path__ + "static/media/insightdata_profil.2281e2c3.svg";